export const HEADER_STEPS = [
  {
    step: 1,
    title: 'Step 1. Enter your URL',
  },
  {
    step: 2,
    title: 'Step 2. Review Report',
  },
  {
    step: 3,
    title: 'Step 3. Claim your Leads',
  },
];

export const AVERAGE_WEB_CONVERSION_RATE = 0.02;
export const WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY = 0.2;
export const AVERAGE_WEB_TRAFFIC_GROWTH =
  WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY - AVERAGE_WEB_CONVERSION_RATE;
export const MAX_TRAFFIC_THRESHOLD = 25000;
export const MAX_LOST_LEADS_THRESHOLD = 50;
export const REDUCE_COST_PER_LEAD = 6.67;
export const SPLIT_NUMBER_BY_THOUTHANDS = /\B(?=(\d{3})+(?!\d))/g;
export const DOMAIN_WITH_PROTOCOLS_REGEX =
  /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/gim;

export const PROTOCOLS_IN_URL = /(^\w+:|^)\/\//;

export const beautifyNumber = (num: any, toFixed: number = 0) => {
  if (typeof num === 'number') {
    return num.toFixed(toFixed).replace(SPLIT_NUMBER_BY_THOUTHANDS, ',');
  }
  return num;
};

export const extractDomainName = (URL: string) => {
  return URL.replace('/report/', '')
    .match(DOMAIN_WITH_PROTOCOLS_REGEX)?.[0]
    .replace(PROTOCOLS_IN_URL, '')
    .replace('www.', '')
    .split('%2')?.[0];
};
